/* storybook-check-ignore */
export default function SelfTourIcon({
  color = '#082DE6',
  size = 16,
}: {
  color?: string;
  size?: string | number;
}) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.8">
        <rect width="16" height="16" transform="translate(0 0.000244141)" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.4794 4.1377H10.2822V2.6377H12.9794C13.5317 2.6377 13.9794 3.08541 13.9794 3.6377V12.3691C13.9794 12.9214 13.5317 13.3691 12.9794 13.3691H10.2825V11.8691H12.4794V4.1377Z"
          fill={color}
        />
        <path
          d="M3 3.47639C3 3.03927 3.28392 2.6528 3.70105 2.52212L8.41085 1.04667C9.05492 0.844905 9.70979 1.32601 9.70979 2.00094V14.1346C9.70979 14.8148 9.04539 15.2965 8.39891 15.085L3.68911 13.5445C3.27804 13.41 3 13.0265 3 12.594V3.47639Z"
          fill={color}
        />
      </g>
    </svg>
  );
}
